var _style, _path, _path2, _g, _g2, _g3, _rect, _rect2, _rect3, _path3, _polygon, _polygon2, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3000px",
    height: "3000px",
    viewBox: "0 0 3000 3000",
    style: {
      enableBackground: "new 0 0 3000 3000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFF1E6;}\r\n\t.st1{fill:#F995AD;}\r\n\t.st2{fill:#C1C1C1;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#353535;}\r\n\t.st5{fill:#231815;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2931.2,2917H56.6V56.5h2874.7V2917H2931.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2893,231.7H93V93h2800V231.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2539.9,
    y: 113.7,
    className: "st2",
    width: 96.8,
    height: 96.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2543.3,207.1 2538.3,212.1 2538.3,112.1 2638.3,112.1 2633.3,117.1 2543.3,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2638.3,212.1 2538.3,212.1 2543.3,207.1 2633.3,207.1 2633.3,117.1 2638.3,112.1  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2656.5,
    y: 113.7,
    className: "st2",
    width: 96.8,
    height: 96.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2659.9,207.1 2654.9,212.1 2654.9,112.1 2754.9,112.1 2749.9,117.1 2659.9,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2754.9,212.1 2654.9,212.1 2659.9,207.1 2749.9,207.1 2749.9,117.1 2754.9,112.1  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2773.1,
    y: 113.7,
    className: "st2",
    width: 96.8,
    height: 96.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2776.5,207.1 2771.5,212.1 2771.5,112.1 2871.5,112.1 2866.5,117.1 2776.5,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2871.5,212.1 2771.5,212.1 2776.5,207.1 2866.5,207.1 2866.5,117.1 2871.5,112.1  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2565.8,
    y: 175.6,
    className: "st5",
    width: 45.1,
    height: 5.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2818.8,
    y: 138.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 712.598 2042.2181)",
    className: "st5",
    width: 5.3,
    height: 45.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2799,
    y: 158.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 712.5677 2042.2908)",
    className: "st5",
    width: 45.1,
    height: 5.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2681.1,141.1V181h45.1v-39.9H2681.1z M2720.8,175.6h-34.4v-29.2h34.4V175.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.4,2915.2 60.4,2915.2 60.4,60.2 2929.9,60.2 2929.9,65.2 65.4,65.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "60.4,2922.9 50.4,2922.9 50.4,50.4 2937.4,50.4 2937.4,60.4 60.4,60.4 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "2937.4,50.4 2937.4,2922.9 50.4,2922.9 60.4,2912.9 2927.4,2912.9 2927.4,60.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.985c00207f6421572dc8447a94bb31fd.svg";
export { ForwardRef as ReactComponent };